import { useMemo } from "react";
import { PlanComponentPageKey } from "@labs/shared/types/PlanComponentPageKey.ts";

import { SummaryAccordion } from "./SummaryAccordion.tsx";
import { ButtonMode } from "../types/ButtonMode.ts";
import { useLocalUserState } from "../util/useLocalUserState.ts";
import { planComponentPageKeyHrefMap } from "@labs/shared/data/planComponentPageKeyHrefMap.ts";
import { SummaryListItem } from "../types/SummaryListItem.ts";

type PlanSummaryAccordionProps = {
  planComponentPageKey: PlanComponentPageKey;
  header: string;
  textContent: SummaryListItem[];
};

export const PlanSummaryAccordion = ({
  planComponentPageKey,
  header,
  textContent,
}: PlanSummaryAccordionProps) => {
  const [user] = useLocalUserState();

  // for users who have saved data prior to this field being added, be extra safe
  const safeViewedPlanComponents = useMemo(
    () => user.viewedPlanComponents || [],
    [user],
  );

  return (
    <SummaryAccordion
      header={header}
      buttonText={
        safeViewedPlanComponents.includes(planComponentPageKey)
          ? "Edit"
          : "Start"
      }
      buttonMode={
        safeViewedPlanComponents.includes(planComponentPageKey)
          ? ButtonMode.Edit
          : ButtonMode.Start
      }
      buttonHref={planComponentPageKeyHrefMap[planComponentPageKey]}
      textContent={textContent}
    />
  );
};
